// extracted by mini-css-extract-plugin
export var externalLink = "_bm-0";
export var internalLinkLabel = "_bm-1";